import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View } from 'react-native';
import {CustomerInfo} from './customer.js'
import {ServiceInfo} from './service.js'
import {Doing} from './doing.js'
import {Done} from './done.js'
import {Invoice} from './invoice.js'
import {CompleteScreen} from './completeTask/index.js'
import {useSelector, useDispatch} from 'react-redux';


const  width= Dimensions.get('window').width-40
export const DoingScreen = ({ route }) => {
  const data = useSelector( state => state.request.data);
  return (
      <Layout level='3' style={styles.container}>
        <SafeAreaView>
          <ScrollView>
            <View style={{justifyContent:'space-between', alignItems:'center'}}>
              <CustomerInfo details={data} />

              { (data.status === 'accept' || data.status === 'deliver') &&
                <Invoice />
              }
              { (data.status === 'doing')  &&
                <Invoice />
              }

            </View>
          </ScrollView>
        </SafeAreaView>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
});
